import { render, staticRenderFns } from "./BlockLoader.vue?vue&type=template&id=267eb938&"
import script from "./BlockLoader.vue?vue&type=script&lang=js&"
export * from "./BlockLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports